import {useEffect} from '@wordpress/element';
import {FeaturedDeal} from './FeaturedDeal';
import {CategoryIconCarousel} from './CategoryIconCarousel';
import {TabbedProductGrid} from './TabbedProductGrid';
import {PopularRetailersStrip} from "./PopularRetailersStrip";
import {useLanding} from "../../store/landing";
import {WordpressAlignWide} from "../common/WordpressAlignWide";

export const LandingPage = () => {
    const {loading, error, fetchLanding} = useLanding();

    useEffect(() => {
        fetchLanding();
    }, []);

    return (
        <div className="w-full pb-20 pt-10">
            <WordpressAlignWide>
                <CategoryIconCarousel loading={loading}/>

                <FeaturedDeal loading={loading}/>

                <PopularRetailersStrip loading={loading}/>

                <TabbedProductGrid loading={loading}/>

                {error && (
                    <div className="alert alert-error my-8 shadow-sm">
                        <span>Failed to load landing content.</span>
                    </div>
                )}
            </WordpressAlignWide>
        </div>
    );
};
